import { GeneralModel } from "./general.model";
export class ChargedCOD extends GeneralModel  {
    id: number;
    districtIds: number[];    
}